exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qmodii .theme--light.v-subheader{color:rgba(0,0,0,.54)}.qmodii .theme--dark.v-subheader{color:hsla(0,0%,100%,.7)}.qmodii .v-subheader{align-items:center;display:flex;height:48px;font-size:14px;font-weight:500;padding:0 16px 0 16px}.qmodii .v-subheader--inset{margin-left:56px}", ""]);

// exports
